import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'decamel',
  standalone: true
})
export class DecamelPipe implements PipeTransform {

  transform(value: string): unknown {
    if(typeof value !== "string") return value;
    return value
      .replace('_','')
      .replace(/([A-Z]|\d+)/g, (match) => ` ${match}`)
      .replace(/^./, (match) => match.toUpperCase())
  }

}
